import { onUnmounted, ref, watch } from "vue";

export function useAnimationNum(initialValue: number, duration: number = 800) {
	const displayNumber = ref(initialValue);
	const targetNumber = ref(initialValue);
	let animationFrameId: number | null = null;
	let startTime: number | null = null;
	let startValue = initialValue;

	const animate = (timestamp: number) => {
		if (!startTime) startTime = timestamp;
		const elapsed = timestamp - startTime;
		const progress = Math.min(elapsed / duration, 1);

		const easing = progress < 0.5 ? 4 * progress * progress * progress : 1 - (-2 * progress + 2) ** 3 / 2;

		displayNumber.value = Math.round(startValue + (targetNumber.value - startValue) * easing);

		if (progress < 1) {
			animationFrameId = requestAnimationFrame(animate);
		} else {
			displayNumber.value = targetNumber.value;
			animationFrameId = null;
		}
	};

	watch(
		targetNumber,
		() => {
			if (animationFrameId) {
				cancelAnimationFrame(animationFrameId);
			}
			startValue = displayNumber.value;
			startTime = null;
			animationFrameId = requestAnimationFrame(animate);
		},
		{ immediate: true },
	);

	onUnmounted(() => {
		if (animationFrameId) {
			cancelAnimationFrame(animationFrameId);
		}
	});

	return {
		displayNumber,
		targetNumber,
		update: (value: any) => {
			targetNumber.value = Number(value);
		},
	};
}
